<template>
	<div>
		<van-popup v-model="popupVisible" :close-on-click-overlay="false" position="center" round>
			<div class="agree_content">
				<div class="title">
					用户协议和隐私政策
				</div>
				<div class="xiyibox">
					<span style="color: rgba(29, 29, 29, 1);font-size: 0.7rem;">为了更好地保护您的合法权益，请您阅读并同意39游戏盒子</span>
					<span @click="goAgreement(1)" style="color:#855200;font-size: 0.7rem;">《服务协议》</span>
					<span style="color: rgba(29, 29, 29, 1);font-size: 0.7rem;">和</span>
					<span @click="goAgreement(2)" style="color:#855200;font-size: 0.7rem;">《隐私政策》</span>
				</div>
				<div class="btn">
					<single-button text='不同意' width="5.9rem" height="1.7rem" background="transparent" color="#8E8E8E"
						border="0.05rem solid #8E8E8E" @know='doClose' class="btn1">
					</single-button>
					<single-button text='同意' width="5.9rem" height="1.7rem" color="#FFDB89"
						@know="doAgree"></single-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { baseURL } from "../../ajax";
import { sendSms } from "@/api/auth.js"
// import { SecretModule } from "@/utils/router.js"
// import { getAPPName } from '@/utils/index.js'

export default {
	name: "AgreeClausePopup",
	props: {
		seletBtndata: {
			type: Boolean,
			default: false,
		},
		telNumber: {
			type: String,
			default: '',
		},
		state: {
			type: Number,
			default: 0,
		}
	},
	data() {
		return {
			// appName: getAPPName(),
			popupVisible: false
		};
	},
	mounted() {
		if (this.open) {
			this.doOpen();
		}
	},
	methods: {
		goAgreement(type) {
			switch (type) {
				// 用户协议
				case 1:
					this.$emit('goAgreement', 1)
					break;
				// 隐私政策
				case 2:
					this.$emit('goAgreement', 2)
					break;
				case 3:
					this.$emit('goAgreement', 3)
					break;
				default:
					break;
			}
		},
		// 在验证码登录页面触发的事件
		verification() {
			this.$store.commit('popup/setloginpop', false)
		},

		// 同意并继续
		doAgree() {
			if (this.state > 0) {
				this.$emit('send')
				this.doClose()
				return
			}
			let phon = this.telNumber;
			sendSms({
				phone: phon,
				action: 'login',
			});
			this.$router.push({
				path: '/pages/index/verification/verification',
				query: { phone: phon }
			})
			this.verification()
			this.doClose()
		},

		doOpen() {
			this.popupVisible = true;
			console.log(this.popupVisible);
		},

		doClose() {
			this.popupVisible = false;
			console.log(this.popupVisible);
		},
	},

}
</script>

<style lang="scss" scoped>
.agree_content {
	width: 15.5rem;
	padding: 0 0.7rem;
	box-sizing: border-box;
	border-radius: 0.5rem;
	background: linear-gradient(180deg, #FFF3D4 0%, #FFFFFF 40%);
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	position: relative;
	overflow-x: hidden;
	.title {
		font-weight: bold;
		color: #000000;
		padding-top: 1.55rem;
		font-size: 1rem;
	}

	.xiyibox {
		padding: 1rem 0;
	}

	.btn {
		width: 17rem;
		padding: 0 1rem;
		padding-bottom: 2rem;
		display: flex;
		justify-content: center;
		align-items: center;

		.btn1 {
			margin-right: 1.15rem !important;
		}
	}

	.img {
		position: absolute;
		display: block;
		width: 0.925rem;
		height: 0.925rem;
		bottom: -3rem;
	}
}
</style>